import { Directive, HostListener, Input } from '@angular/core';
import { NumericInputHelperUtil } from '@zero/shared/util-helper';

@Directive({
  selector: '[zeroCurrencyInput]',
  standalone: true,
})
export class CurrencyInputDirective {
  @Input() public isCurrency = true;

  @HostListener('keydown', ['$event'])
  public onKeyDown(ev: KeyboardEvent) {
    if (!this.isCurrency) {
      return;
    }

    NumericInputHelperUtil.handleKeydown(ev);

    const inputElement = ev.target as HTMLInputElement;

    // Get the current value of the input and the position of the cursor
    let currentValue = inputElement.value;
    if (!currentValue) {
      return;
    }
    const cursorPosition = inputElement.selectionStart ?? currentValue.length;

    // Check if a decimal point is present, replace dot with comma
    const decimalSeperator = ',';
    currentValue = currentValue.replace('.', decimalSeperator);
    const decimalIndex = currentValue.indexOf(decimalSeperator);

    // Check if the key pressed is a number
    const isNumber = ev.key >= '0' && ev.key <= '9';

    if (isNumber && decimalIndex !== -1 && cursorPosition > decimalIndex) {
      const decimals = currentValue.split(decimalSeperator)[1]?.length || 0;

      // Prevent input if the number of decimals exceeds the allowed limit
      if (decimals >= 2) {
        ev.preventDefault();
      }
    }
  }
}
